<template>
  <div id="app" class="page">
    <!-- 头部 -->
    <ToolsHead></ToolsHead>
    <!-- 路由占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
import ToolsHead from './components/head/ToolsHead.vue'
export default {
  name: "app",
  components: {
    ToolsHead
  },
  data() {
    return {
      
    }
  },
  computed: {
  },
  mouted(){
    
  },
  beforeMount() {  
    
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.page{
  min-width: 1000px;
}
</style>
